exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sample-banner[data-v-26d6e1dd]{display:flex;align-items:center;gap:12px;margin-top:8px;margin-bottom:8px;padding:10px 14px;border:1px solid #f2d99a;border-radius:var(--inistate-rounded-4,4px);background:#fff8e6;font-size:13px;line-height:1.45;color:#6b4a00}.sample-banner__text[data-v-26d6e1dd]{flex:1}.sample-banner__clear[data-v-26d6e1dd]{flex:none;padding:4px 10px;border:1px solid #e0c27a;border-radius:var(--inistate-rounded-4,4px);background:#fff;font-size:13px;font-weight:var(--inistate-font-weight-medium,500);color:#8a5a00;cursor:pointer}.sample-banner__clear[data-v-26d6e1dd]:disabled{opacity:.65;cursor:not-allowed}", ""]);

// exports
